import { apiRequest } from "@/shared/lib/apiClient";

export type SupportRequest = {
  id: number;
  category: "plainte" | "requete";
  category_label: string;
  subject: string;
  message: string;
  status: "open" | "answered" | "closed";
  status_label: string;
  reply: string | null;
  author: string;
  author_role: string;
  replied_by: string | null;
  replied_at: string | null;
  created_at: string;
};

/** Date du serveur (UTC, « 2026-11-04 09:50:26 ») en heure locale. */
export function supportDate(value: string): string {
  return new Date(`${value.replace(" ", "T")}Z`).toLocaleString("fr-FR");
}

/** Plaintes et requêtes envoyées par le compte connecté. */
export async function fetchMySupportRequests(): Promise<SupportRequest[]> {
  const response = await apiRequest<{ requests: SupportRequest[] }>("/support/requests", { auth: true });
  return response.requests;
}

export async function sendSupportRequest(payload: { category: SupportRequest["category"]; subject: string; message: string }): Promise<SupportRequest> {
  const response = await apiRequest<{ request: SupportRequest }>("/support/requests", { method: "POST", auth: true, body: payload });
  return response.request;
}

/** Admin : toutes les plaintes et requêtes. */
export async function fetchSupportRequests(status = ""): Promise<SupportRequest[]> {
  const response = await apiRequest<{ requests: SupportRequest[] }>(`/admin/support/requests${status ? `?status=${status}` : ""}`, { auth: true });
  return response.requests;
}

export async function answerSupportRequest(id: number, payload: { reply?: string; close?: boolean }): Promise<SupportRequest> {
  const response = await apiRequest<{ request: SupportRequest }>(`/admin/support/requests/${id}`, { method: "PUT", auth: true, body: payload });
  return response.request;
}
